import { get } from "api/Base.api";
import { INotice } from "api/interfaces/bbs.interface";
import { IPagination } from "api/interfaces/common.interface";

// 공지사항 목록 조회 응답 인터페이스
export interface INoticeListResponse {
    noticeList: INotice[];
    pagination: IPagination;
}

/**
 * 캐스팅 매니저용 공지사항 목록 조회
 * GET /agency/v2/notice
 */
export const getNoticeList = async (page: number = 1): Promise<INoticeListResponse> => {
    return await get('/agency/v2/notice', { page });
};

// 공지사항 상세 조회 응답 인터페이스
export interface INoticeDetailResponse {
    notice: INotice;
}

/**
 * 캐스팅 매니저용 공지사항 상세 조회
 * GET /agency/v2/notice/:noticeId
 */
export const getNoticeDetail = async (id: number): Promise<INoticeDetailResponse> => {
    return await get(`/agency/v2/notice/${id}`);
};
